<template>
  <div style="min-width: 25px; max-width: 25px">
    <div>
      <ui-icon
        v-if="!selectedKeysIndex[item.name]"
        icon="far fa-square"
        :color="$colors.gray50"
        size="16"
      ></ui-icon>
      <ui-icon v-else icon="fas fa-check-square" :color="$colors.green" size="16"></ui-icon>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useColors } from '@/composables';

const $colors = useColors();

defineProps<{
  selectedKeysIndex: Record<string, boolean>;
  item: { name: string };
  prefix: string;
  noEvents?: boolean;
}>();
</script>
